export default __webpack_public_path__ + "cd2491c30c7f25218ecd04a956817182.woff2";